import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface SubscriptionPreferencesFormProps {
  formData: {
    paymentMethod: string;
    sentiment: number;
  };
  updateFormData: (key: string, value: any) => void;
}

export const SubscriptionPreferencesForm: React.FC<
  SubscriptionPreferencesFormProps
> = ({ formData, updateFormData }) => {
  return (
    <AccordionItem value="preferences">
      <AccordionTrigger>Preferences</AccordionTrigger>
      <AccordionContent className="px-2">
        <div className="space-y-4 pt-2">
          {/* Payment Method */}
          <div className="space-y-2">
            <Label htmlFor="paymentMethod" className="text-sm font-medium">
              Payment Method (Optional)
            </Label>
            <Input
              id="paymentMethod"
              value={formData.paymentMethod}
              onChange={(e) => updateFormData("paymentMethod", e.target.value)}
              placeholder="Visa ****1234, PayPal, etc."
              className="glass-surface"
            />
          </div>

          {/* Sentiment */}
          <div className="space-y-3">
            <Label id="sentiment-label" className="text-sm font-medium">
              How do you feel about this subscription?
            </Label>
            <div className="flex items-center justify-between px-2">
              <span className="text-2xl">😠</span>
              <RadioGroup
                aria-labelledby="sentiment-label"
                value={String(formData.sentiment)}
                onValueChange={(v) => updateFormData("sentiment", parseInt(v))}
                className="flex flex-row gap-3"
              >
                {["1", "2", "3", "4", "5"].map((v) => (
                  <div key={v} className="flex items-center space-x-2">
                    <RadioGroupItem id={`sentiment-${v}`} value={v} />
                    <Label
                      htmlFor={`sentiment-${v}`}
                      className="sr-only"
                    >{`Set rating ${v}`}</Label>
                  </div>
                ))}
              </RadioGroup>
              <span className="text-2xl">😍</span>
            </div>
          </div>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
